export default "__VITE_ASSET__DsSToNx0__"